const base = () => process.env.REACT_APP_API_URI || '';

async function parse(response) {
    const body = await response.json().catch(() => null);
    if (!response.ok) {
        throw new Error(body?.message || `Serverantwort ${response.status}`);
    }
    return body;
}

export async function fetchJson(path) {
    return parse(await fetch(`${base()}${path}`));
}

export async function postJson(path, payload) {
    return parse(await fetch(`${base()}${path}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    }));
}
